import axios, { CancelTokenSource, AxiosError, AxiosResponse } from 'axios';
import 'bootstrap/dist/css/bootstrap.css';
import React, { Fragment } from 'react';
import { FaBuilding, FaCar, FaHome } from 'react-icons/fa';
import { ReactComponent as CondoImg } from '../Images/condo.svg'
import { connect } from 'react-redux';
import { Button, Col, Container, Input, Row } from 'reactstrap';
import '../custom.scss';
import './StartQuotePage.scss';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { ApplicationState } from '../store';
import { AgencyInfoPosition, State } from '../store/Site/state';
import { homeownersType } from '../store/Quote/state';
import { Action as QuoteAction, actionCreators as QuoteActions } from '../store/Quote/actions';
import { Action as StepperAction, actionCreators as StepperActions } from '../store/Stepper/actions';
import { Action as ValidationAction, actionCreators as ValidationActions } from '../store/Validation/actions';
import { ThunkDispatch } from 'redux-thunk';
import { updateCrqPage } from '../services/historyWrapper';
import { getBaseUrl, getQueryStringLob } from '../services/helper';
import errorResponseHandler from '../services/errorHandling';
import { useMediaQuery } from 'react-responsive';
import { StepType, stepPage } from '../store/Stepper/state';
import { subscribeToQuoteChanges } from '../store/configureStore';
import Pdf from '../Documents/ConsumerRateQuotes_TermsAndConditions.pdf';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import Carousel from 'nuka-carousel';
import { CarrierImages } from '../models/carrierImages';
import HelpText from './HelpText';
import CanopyConnect from './CanopyConnect';
import classNames from 'classnames';

export class AddressSuggestion {
  display: string = '';
  address: string = '';
  city: string = '';
  state: string = '';
  zipCode: string = '';
  verified: boolean = false;
  hasSuites: boolean = false;
}

type StartQuotePageProps =
  ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

interface StartQuotePageState {
  isPersonalAuto: boolean,
  homeowners: homeownersType,
  fullAddress: string,
  addressLine1: string,
  addressLine2: string,
  city: string,
  zip: string,
  addressVerified: boolean,
  addressHasSuites: boolean,
  isStartButtonEnabled: boolean,
  hideAutoLabel: boolean,
  hideHomeownersLabel: boolean,
  addressState: string,
  isStateValid: boolean,
  suggestions: AddressSuggestion[],
  errorText: string,
  isLoading: boolean,
  autoFocus: boolean,
  carrierImages: CarrierImages[],
  showCanopyConnectWidget: boolean;
  packageOnly: boolean;
  monolineOnly: boolean;
}

class StartQuotePage extends React.PureComponent<StartQuotePageProps, StartQuotePageState> {

  constructor(props: any) {
    super(props);

    const isAutoFocus = getQueryStringLob(window.location).length > 0;

    let isPersonalAuto = false;
    let isHideAuto: boolean = true;
    let isHideHomeowners: boolean = true;
    let site = this.props.site;
    let packageOnly = site.lobSelection === 'Package Only';
    let monolineOnly = site.lobSelection === 'Monoline Only';

    for (let i: number = 0; i < site.linesOfBusiness!.length; i++) {
      if (site.linesOfBusiness![i].abbreviation === 'PA') {
        isHideAuto = false;
      }
      if (site.linesOfBusiness![i].abbreviation === 'HO') {
        isHideHomeowners = false;
      }
    }

    if (!isHideAuto && isHideHomeowners) {
      // no reason to show auto stuff if homeowners is not shown
      isHideAuto = true;
      // go ahead and select auto because input should be hidden
      isPersonalAuto = true;
    }
    else if (packageOnly) {
      // go ahead and select auto if CRQ is setup to only allow package quotes
      isPersonalAuto = true;
    }

    this.state = {
      isPersonalAuto: isPersonalAuto,
      homeowners: homeownersType.None,
      fullAddress: '',
      addressLine1: '',
      addressLine2: '',
      city: '',
      zip: '',
      addressVerified: false,
      addressHasSuites: false,
      isStartButtonEnabled: false,
      hideAutoLabel: isHideAuto,
      hideHomeownersLabel: isHideHomeowners,
      addressState: '',
      isStateValid: true,
      suggestions: [],
      errorText: '',
      isLoading: false,
      autoFocus: isAutoFocus,
      carrierImages: [],
      showCanopyConnectWidget: false,
      packageOnly: packageOnly,
      monolineOnly: monolineOnly
    };

    this.handleAuto = this.handleAuto.bind(this);
    this.handleHomeowners = this.handleHomeowners.bind(this);
    this.enableStartButton = this.enableStartButton.bind(this);
    this.clearSuggestions = this.clearSuggestions.bind(this);
    this.continueQuote = this.continueQuote.bind(this);
    this.addressAutoFill = this.addressAutoFill.bind(this);
  }

  canopyConnectStart = () => {
    this.setState({ showCanopyConnectWidget: true });
  };


  canopyConnectClose = (doImport: boolean) => {
    if (doImport === true) {
      //update quote and go to wait page
      this.updateQuote(StepType.Wait);
    }
    this.setState({ showCanopyConnectWidget: false });
  };

  componentDidMount() {
    //For lob startup parameters
    var queryStringLob = getQueryStringLob(window.location);
    var isPersonalAuto = this.state.isPersonalAuto;
    var homeowners = homeownersType.None;

    if (queryStringLob.includes('auto')) {
      isPersonalAuto = true;
      queryStringLob = queryStringLob.slice(5);
    }

    switch (queryStringLob) {
      case 'home':
        homeowners = homeownersType.Homeowner;
        break;
      case 'rent':
        homeowners = homeownersType.Renters;
        break;
      case 'condo':
        homeowners = homeownersType.CondoOwner;
        break;
    }

    this.setState({ isPersonalAuto: isPersonalAuto, homeowners: homeowners });

    // if starting a new quote from a quote where errors were visible, we need to clear them
    this.props.updateErrorsVisible(false);

    // gets agency carriers for images
    axios.get(`${getBaseUrl()}/carrierImages/${this.props.site.id}`)
      .then((response) => {
        this.setState({
          carrierImages: response.data,
        });
      })
      .catch((error: AxiosError) => {
        if (!axios.isCancel(error)) {
          errorResponseHandler(error);
        }
      });
  }


  render() {
    return (
      <Container>
        {this.renderHeaderText()}
        <this.renderLOBSelectionIcons /> {/*Must be a react function to use media query*/}
        {this.renderAddressInput()}
        {this.props.stepper.selected !== StepType.None &&
          <Button color="link" className="align-bottom p-0" onClick={this.continueQuote}>
            Continue existing quote
          </Button>
        }
        <this.renderCarrierImages />
        {this.renderDisclaimer()}
      </Container>
    );
  }

  renderHeaderText() {
    let introTitle = this.props.site.introTitle || '';
    let introMsg = this.props.site.introScreenMsg || '';
    let selectLine1 = 'Select One or Bundle!';
    let selectLine2 = 'You can select either Homeowners, Renters, or Condo Owners alone or bundle it with Auto!';

    if (this.state.hideAutoLabel || this.state.monolineOnly || this.state.packageOnly) {
      selectLine1 = 'Select One!';
    }

    if (this.state.monolineOnly) {
      selectLine2 = 'You can select either Auto, Homeowners, Renters, or Condo Owners!';
    }

    if (this.state.packageOnly) {
      selectLine2 = 'You can select either Homeowners, Renters, or Condo Owners to bundle with auto!'
    }

   
     let mainMsg = introTitle;

    let mainClassName = 'text-center mt-3 start-quote-page__header-text-main';
    if (introMsg !== '') {
      // has intro msg, need a little space for intro msg
      mainClassName = classNames('mb-1', mainClassName);
    }
    else {
      if (this.state.hideHomeownersLabel) {
        // no intro msg and no home, so no select labels, needs small space for address
        mainClassName = classNames('mb-3', mainClassName);
      }
      else {
        // no intro msg and home, needs big space for select
        mainClassName = classNames('mb-5', mainClassName);
      }
    }

    let introClassName = 'text-center mt-1 start-quote-page__header-text-intro';
    if (this.state.hideHomeownersLabel) {
      // no home, so no select labels, needs small space for address
      introClassName = classNames('mb-3', introClassName);
    }
    else {
      // has home, so has select labels, needs large space for select labels
      introClassName = classNames('mb-5', introClassName);
    }

    let select1ClassName = 'text-center mt-2 start-quote-page__header-text-select1';
    if (this.state.hideAutoLabel) {
      // no auto, so no select 2 label, needs small space for lob selection
      select1ClassName = classNames('mb-2', select1ClassName);
    }
    else {
      // has auto, so has select 2 label, needs small space for select 2 label
      select1ClassName = classNames('mb-1', select1ClassName);
    }

    return (
      <Fragment>
        <div className={mainClassName}>{mainMsg}</div>

        {introMsg !== '' &&
          <div data-testid='introMsg' className={introClassName}>{introMsg}</div>
        }

        {/* Only show when home or package */}
        {!this.state.hideHomeownersLabel &&
          <div data-testid='selectHeader' className={select1ClassName}>{selectLine1}</div>
        }
        {!this.state.hideHomeownersLabel && !this.state.hideAutoLabel &&
          <div data-testid='selectHeader2' className='text-center mt-2 mb-2 text-muted start-quote-page__header-text-select2'>{selectLine2}</div>
        }
      </Fragment>
    )
  }

  renderLOBSelectionIcons = () => {
    let outerContainerStyle = 'offset-2 offset-md-1 offset-lg-2 offset-xl-3 start-quote-page__lob-col-xxs col-8 col-md-10 col-lg-8 col-xl-6'
    if (this.props.site.agencyInfoPosition === AgencyInfoPosition.Left) {
      // left needs different zones in some areas to account for space taken up on left for image and agency info
      outerContainerStyle = 'offset-2 offset-md-1 offset-xl-2 start-quote-page__lob-col-xxs col-8 col-md-10 col-xl-8'
    }

    return (
      <Fragment>
        <Row data-testid='lobIcons'>
          <Col className={outerContainerStyle}>
            <Row>
              <Col xs='6' md='3' className='btn-group btn-group-toggle start-quote-page__lob-selector' data-toggle='buttons' hidden={this.state.hideAutoLabel} data-testid='autoIcon'>
                <label className={classNames('btn start-quote-page__btn-lob w-100 h-100', {active: this.state.isPersonalAuto || this.state.packageOnly})} id='autoLabel' data-testid='autoLabel'>
                  <FaCar size={64} />
                  <div><input type="checkbox" name="personalAuto" id="auto" onChange={this.handleAuto} checked={this.state.isPersonalAuto} data-testid='autoCheckbox' />Auto</div>
                </label>
              </Col>

              <Col xs='6' md='3' className='btn-group btn-group-toggle start-quote-page__lob-selector' data-toggle='buttons' hidden={this.state.hideHomeownersLabel} data-testid='homeIcon'>
                <label className={classNames('btn start-quote-page__btn-lob w-100 h-100 homeOwnerLabels', {active: this.state.homeowners === homeownersType.Homeowner})} id='homeLabel' data-testid='homeLabel'>
                  <FaHome size={64} />
                  <div><input type="checkbox" name="homeowners" id="home" value={homeownersType.Homeowner}
                    onChange={this.handleHomeowners} checked={this.state.homeowners === homeownersType.Homeowner} />Homeowners</div>
                </label>
              </Col>

              <Col xs='6' md='3' className='btn-group btn-group-toggle start-quote-page__lob-selector' data-toggle='buttons' hidden={this.state.hideHomeownersLabel} data-testid='rentersIcon'>
                <label className={classNames('btn start-quote-page__btn-lob w-100 h-100 homeOwnerLabels', {active: this.state.homeowners === homeownersType.Renters})} id='rentersLabel' data-testid='rentersLabel'>
                  <FaBuilding size={64} />
                  <div><input type="checkbox" name="homeowners" id="renters" value={homeownersType.Renters}
                    onChange={this.handleHomeowners} checked={this.state.homeowners === homeownersType.Renters} />Renters</div>
                </label>
              </Col>

              <Col xs='6' md='3' className='btn-group btn-group-toggle start-quote-page__lob-selector' data-toggle='buttons' role='group' hidden={this.state.hideHomeownersLabel} data-testid='condoIcon'>
                <label className={classNames('btn start-quote-page__btn-lob w-100 h-100 text-nowrap homeOwnerLabels', {active: this.state.homeowners === homeownersType.CondoOwner})} id='condoLabel' data-testid='condoLabel'>
                  <CondoImg />
                  <div><input type="checkbox" name="homeowners" id="condo" value={homeownersType.CondoOwner}
                    onChange={this.handleHomeowners} checked={this.state.homeowners === homeownersType.CondoOwner} /><span className='start-quote-page__text-overflow-center'>Condo Owners</span></div>
                </label>
              </Col>
            </Row>
          </Col>
        </Row>
      </Fragment>
    )
  }

  renderAddressInput() {
    return (
      <Fragment>
        <Row className='mt-2'>
          <Col xs={this.state.addressHasSuites ? 8 : 12} sm={this.state.addressHasSuites ? 10 : 12}>
            <AsyncTypeahead
              id='address2'
              isLoading={this.state.isLoading}
              minLength={5}
              onSearch={this.addressAutoFill}
              labelKey='display'
              options={this.state.suggestions}
              placeholder='Enter Your Home Address'
              flip={true}
              delay={250}
              autoFocus={this.state.autoFocus}
              // always return true and trust the server side code for options.  otherwise, options that do not match typed text will not display.
              filterBy={() => true}
              onChange={(suggestion) => this.clearSuggestions(suggestion[0] as AddressSuggestion)}
            />
          </Col>
          <Col xs={this.state.addressHasSuites ? 4 : 0} sm={this.state.addressHasSuites ? 2 : 0}>
            <Input hidden={!this.state.addressHasSuites} color='primary' id='suiteInput' maxLength={10}
              placeholder='Apt/Unit' name='addressLine2' onChange={(e) => this.handleChange(e)}></Input>
            </Col>
        </Row>
        <Row>
          <Col className='text-center mt-4'>
            <Button disabled={!this.state.isStartButtonEnabled} color='primary' id='startButton' data-testid='startButton' className='start-quote-page__start-button'
              onClick={() => this.updateQuote(StepType.ApplicantDrivers)}>Start My New Quote</Button>
          </Col>
        </Row>
        <Row hidden={!this.props.site.displayCanopyConnect} data-testid='canopyConnectSection'>
          <Col className='text-center mt-1'>
            <Button id='canopyConnectLink' color="link" tabIndex={-1} data-testid='canopyConnectLink' className='p-0 mr-1 start-quote-page__import'
              onClick={this.canopyConnectStart} disabled={!this.state.isStartButtonEnabled}>
              Import My Existing Insurance
            </Button>
            {this.state.showCanopyConnectWidget && <CanopyConnect publicAlias={this.props.site.canopyConnectPublicAlias} apiRequestImportKey={this.props.site.apiRequestImportKey} onClose={this.canopyConnectClose} />}
            <HelpText text='Easily use Canopy Connect to collect your current insurance information.' helpId='canopyconnect' buttonStyle='start-quote-page__help' />
          </Col>
        </Row>

        <div>
          <small className='text-danger w-100'>
            {this.state.errorText}
          </small>
        </div>
      </Fragment>
    )
  }

  renderDisclaimer() {
    return (
      <div className='text-center mt-4' data-testid='disclaimerText'>
        <p className='text-muted' style={{ fontSize: '0.6rem' }}>
          We may use information from you and other sources, such as your driving record, claims and credit histories to provide you
          with an accurate quote and other important information either via this website, email, phone or text messages. By continuing,
          you (i) authorize us to pull your credit report, (ii) acknowledge that you have reviewed our
          <a href='https://www.vertafore.com/product-privacy-statement' target='_blank' rel='noopener noreferrer'> Privacy Statement </a>
          and <a href={Pdf} target='_blank' rel='noopener noreferrer'> Terms of Use</a>,
          and (iii) consent to the use and processing of all such information.
        </p>
      </div>
    )
  }

  renderCarrierImages = () => {
    var isMobile = useMediaQuery({ maxWidth: 480 });
    var isTablet = useMediaQuery({ maxWidth: 768 });

    return (
      <div className='mt-5' data-testid='carrierImages'>
        <Carousel
          autoplay={true}
          autoplayInterval={2500}
          wrapAround={true}
          disableEdgeSwiping={true}
          dragging={false}
          speed={500}
          withoutControls={true}
          pauseOnHover={false}
          slidesToShow={isMobile ? 2 : (isTablet ? 3 : 4)}
          cellSpacing={10}
        >
          {
            this.state.carrierImages.map((image, i) => {
              return (<img className='carrier__image' src={'data:image/image;base64, ' + image.carrierImage} alt={i + 'Slide'} key={i + 'slide'} />);
            })
          }
        </Carousel>
      </div>
    )
  }

  handleAuto() {
    // If monoline only, toggling auto disables homeowners
    if (this.state.monolineOnly) {
      this.setState(prevState => ({
        isPersonalAuto: !prevState.isPersonalAuto,
        homeowners: homeownersType.None
      }),() => this.verifyLOBinState(this.state.addressState));
      return;
    }

    // If package only, auto is always selected and cannot be toggled
    if (this.state.packageOnly) {
      return;
    }

    // Otherwise, just toggle auto
    this.setState(prevState => ({
      isPersonalAuto: !prevState.isPersonalAuto
    }),() => this.verifyLOBinState(this.state.addressState));
  }

  handleHomeowners = (event: { target: { value: any; }; }) => {
    // If the same homeowners type is clicked, deselect it (set to None)
    if (event.target.value === this.state.homeowners) {
      this.setState({
        homeowners: homeownersType.None
      }, () => this.verifyLOBinState(this.state.addressState))
      return;
    };

    // If monoline only, auto should be always be false,
    // If package only, auto should always be true
    let isPersonalAuto = this.state.isPersonalAuto;
    if (this.state.monolineOnly) {
      isPersonalAuto = false;
    }
    else if (this.state.packageOnly) {
      isPersonalAuto = true;
    }

    this.setState({
      homeowners: event.target.value,
      isPersonalAuto: isPersonalAuto
    }, () => this.verifyLOBinState(this.state.addressState))
  }

  cancelTokenSource: CancelTokenSource | null = null;

  addressAutoFill(query: string) {
    let addressSuggestions: AddressSuggestion[] = [];

    this.setState({
      isLoading: true,
      suggestions: addressSuggestions
    });

    // cancel the previous request if there was one
    if (this.cancelTokenSource) {
      this.cancelTokenSource.cancel();
    }

    this.cancelTokenSource = axios.CancelToken.source();

    axios.get(getBaseUrl() + '/AddressSuggestions?inputAddress=' + encodeURI(query), {
      cancelToken: this.cancelTokenSource.token
    }).then((response) => {
      let address;
      for (let i: number = 0; i < response.data.results.length; i++) {
        address = response.data.results[i].address;

        addressSuggestions[i] = new AddressSuggestion();
        addressSuggestions[i].display = address.addressLine1 + ', ' +
          address.city + ', ' +
          address.state + '  ' +
          address.postalCode.substring(0, 5);
        addressSuggestions[i].address = address.addressLine1;
        addressSuggestions[i].city = address.city;
        addressSuggestions[i].state = address.state;
        addressSuggestions[i].zipCode = address.postalCode;
        addressSuggestions[i].verified = address.verified;
        addressSuggestions[i].hasSuites = address.suiteCount > 1;
      }

      this.setState({
        suggestions: addressSuggestions,
        isLoading: false
      })

      this.cancelTokenSource = null;
    })
      .catch(error => {
        if (!axios.isCancel(error)) {
          this.setState({
            isLoading: false
          })
          errorResponseHandler(error);
        }
      });
  }

  clearSuggestions(suggestion: AddressSuggestion) {
    suggestion = suggestion || '';

    let addressLine1 = '';
    let city = '';
    let addressState = '';
    let zip = '';
    let addressVerified = false;
    let addressHasSuites = false;

    if (suggestion.display != null && suggestion.display.length > 0) {
      //we can assume it is in this format due to selecting a suggestion
      addressLine1 = suggestion.address;
      city = suggestion.city;
      addressState = suggestion.state;
      zip = suggestion.zipCode;
      addressVerified = suggestion.verified;
      addressHasSuites = suggestion.hasSuites;
    }

    this.setState({
      suggestions: [],
      fullAddress: suggestion.display,
      addressLine1,
      city,
      addressState,
      zip,
      addressVerified,
      addressHasSuites
    }, () =>
      this.verifyLOBinState(this.state.addressState)
    )
  }

  enableStartButton() {
    if (this.state.packageOnly) {
      if (this.state.fullAddress != null && this.state.fullAddress.length > 5 && this.state.addressState !== '' && this.state.city !== '' && this.state.zip.length >= 5 &&
        (this.state.homeowners !== homeownersType.None)
        && this.state.isStateValid) {
        this.setState({
          isStartButtonEnabled: true
        })
      }
      else {
        this.setState({
          isStartButtonEnabled: false
        })
      }
    }
    else {
      if (this.state.fullAddress != null && this.state.fullAddress.length > 5 && this.state.addressState !== '' && this.state.city !== '' && this.state.zip.length >= 5 &&
        (this.state.isPersonalAuto === true || this.state.homeowners !== homeownersType.None)
        && this.state.isStateValid) {
        this.setState({
          isStartButtonEnabled: true
        })
      }
      else {
        this.setState({
          isStartButtonEnabled: false
        })
      }
    }
  }

  verifyLOBinState(state: string) {
    let indexPA: number = this.props.site.linesOfBusiness!.findIndex(lineOfBusiness => lineOfBusiness.abbreviation === 'PA');
    let indexHO: number = this.props.site.linesOfBusiness!.findIndex(lineOfBusiness => lineOfBusiness.abbreviation === 'HO');
    let indexPP: number = this.props.site.linesOfBusiness!.findIndex(lineOfBusiness => lineOfBusiness.abbreviation === 'PP');
    let statesPA: State[] = [];
    let statesHO: State[] = [];
    let statesPP: State[] = [];

    if (indexPA > -1) {
      statesPA = this.props.site.linesOfBusiness![indexPA].states;
    }
    if (indexHO > -1) {
      statesHO = this.props.site.linesOfBusiness![indexHO].states;
    }
    if (indexPP > -1) {
      statesPP = this.props.site.linesOfBusiness![indexPP].states;
    }

    let isValid = false;
    let newErrorText = 'Online quoting isn\'t available for that state, please contact the agency directly.';

    if ((this.state.fullAddress != null && this.state.fullAddress.length < 8) || this.state.addressState === '') {
      this.setState({
        errorText: ''
      }, () => this.enableStartButton())
      return;
    }

    let statesToCheck: State[] = [];
    if (this.state.isPersonalAuto === true && this.state.homeowners !== homeownersType.None) {
      statesToCheck = statesPP;
    }
    else if (this.state.isPersonalAuto === true) {
      statesToCheck = statesPA;
    }
    else if (this.state.homeowners !== homeownersType.None) {
      statesToCheck = statesHO;
    }

    if (statesToCheck.length > 0) {
      for (let i: number = 0; i < statesToCheck.length; i++) {
        if (state === statesToCheck[i].abbreviation || state === statesToCheck[i].name.toUpperCase()) {
          isValid = true;
          newErrorText = '';
          break;
        }
      }

      this.setState({
        isStateValid: isValid,
        errorText: newErrorText
      }, () => this.enableStartButton());
      return;
    }
    this.setState({
      isStateValid: isValid,
      errorText: 'Please choose a line of business.'
    }, () => this.enableStartButton())
  }

  continueQuote() {
    subscribeToQuoteChanges();
    updateCrqPage(stepPage[this.props.stepper.selected]);
  }

  handleChange(event: { target: { name: string; value: string; }; }) {
    event.target.value = event.target.value.replace(/[^a-zA-Z0-9 #-]/g, '');
    let { name, value } = event.target

    this.setState({
      ...this.state,
      [name]: value
    });
  }

  formatAddressLine2(address: string) {
    let whitelist: string[] = ['Apartment', 'Apt', 'Suite', 'Ste', 'Unit', '#'];
    let addNumber: boolean = true;

    if (address.length === 0) {
      addNumber = false;
    }
    else {
      for (const text of whitelist) {
        if (address.startsWith(text)) {
          addNumber = false;
          break;
        }
      }
    }

    if (addNumber) {
      address = '#' + address;
    }

    return address;
  }

  updateQuote(nextStep: StepType) {
    axios.get(getBaseUrl() + '/AgencyLicense/' + this.props.site.id + '/' + this.state.addressState)
      .then((response: AxiosResponse<string>) => {
        subscribeToQuoteChanges();

        this.props.startQuote(this.state.isPersonalAuto, this.state.homeowners, this.state.fullAddress,
          this.state.addressState, this.state.addressLine1, this.formatAddressLine2(this.state.addressLine2), this.state.city,
          this.state.zip, this.state.addressVerified, response.data);

        this.props.changeStep(StepType.None, nextStep);
      })
      .catch((error: AxiosError) => {
        errorResponseHandler(error);
      });
  }
}

const mapStateToProps = (state: ApplicationState) => ({
  site: state.site,
  stepper: state.stepper
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, QuoteAction | StepperAction | ValidationAction>) => ({
  startQuote: (isPersonalAuto: boolean, homeowners: homeownersType, fullAddress: string, addressState: string, addressLine1: string,
    addressLine2: string, city: string, zip: string, addressVerified: boolean, agencyLicNum: string) =>
    dispatch(QuoteActions.startQuote(isPersonalAuto, homeowners, fullAddress, addressState, addressLine1, addressLine2, city, zip, addressVerified, agencyLicNum)),
  changeStep: (current: StepType, selected: StepType) => dispatch(StepperActions.changeStep(current, selected)),
  updateErrorsVisible: (errorsVisible: boolean) => dispatch(ValidationActions.updateErrorsVisible(errorsVisible))
})

export default connect(
  mapStateToProps, mapDispatchToProps
)(StartQuotePage as any);